import * as Id_bs$SolvuuApi0 from "./id_bs.bs.js";
import * as S3_bs$SolvuuApi0 from "./s3_bs.bs.js";
import * as Event_bs$SolvuuApi0 from "./event_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Int64_wrap$SolvuuApi0 from "./int64_wrap.bs.js";
import * as Checksum_bs$SolvuuApi0 from "./checksum_bs.bs.js";
var write_storage = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x[0] >= 737307005) {
    return Atdgen_codec_runtime.Encode.constr1("Blob", Id_bs$SolvuuApi0.write_blob, x[1]);
  } else {
    return Atdgen_codec_runtime.Encode.constr1("S3", S3_bs$SolvuuApi0.write_location, x[1]);
  }
});
var read_storage = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Blob",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Blob */
      [737307005, x]
    );
  }, Id_bs$SolvuuApi0.read_blob, param);
}]],
/* :: */
[
/* tuple */
["S3",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `S3 */
      [18560, x]
    );
  }, S3_bs$SolvuuApi0.read_location, param);
}]],
/* [] */
0]]);

function write__5(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(Atdgen_codec_runtime.Encode.$$int, param);
}

var read__5 = Atdgen_codec_runtime.Decode.option_as_constr(Atdgen_codec_runtime.Decode.$$int);

function write__2(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(Atdgen_codec_runtime.Encode.string, param);
}

var read__2 = Atdgen_codec_runtime.Decode.option_as_constr(Atdgen_codec_runtime.Decode.string);
var write_s3_progress_part = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__5, "part_number", t.part_number),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "last_modified", t.last_modified),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "etag", t.etag),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__5, "size", t.size),
  /* [] */
  0]]]]);
});
var read_s3_progress_part = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    part_number: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("part_number", read__5, param);
    }, json),
    last_modified: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("last_modified", read__2, param);
    }, json),
    etag: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("etag", read__2, param);
    }, json),
    size: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("size", read__5, param);
    }, json)
  };
});

function write__6(param) {
  return Atdgen_codec_runtime.Encode.list(write_s3_progress_part, param);
}

function read__6(param) {
  return Atdgen_codec_runtime.Decode.list(read_s3_progress_part, param);
}

var write_s3_progress_report = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "upload_id", t.upload_id),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__6, "parts", t.parts),
  /* [] */
  0]]);
});
var read_s3_progress_report = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    upload_id: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("upload_id", Atdgen_codec_runtime.Decode.string, param);
    }, json),
    parts: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("parts", read__6, param);
    }, json)
  };
});
var write_s3_progress = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x[0] >= 466640422) {
    return Atdgen_codec_runtime.Encode.constr1("Progress_report", write_s3_progress_report, x[1]);
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Upload_id", Atdgen_codec_runtime.Encode.string, x[1]);
  }
});
var read_s3_progress = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Upload_id",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Upload_id */
      [421854841, x]
    );
  }, Atdgen_codec_runtime.Decode.string, param);
}]],
/* :: */
[
/* tuple */
["Progress_report",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Progress_report */
      [466640422, x]
    );
  }, read_s3_progress_report, param);
}]],
/* [] */
0]]);
var write_progress = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr1("S3", write_s3_progress, x[1]);
});
var read_progress = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["S3",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `S3 */
      [18560, x]
    );
  }, read_s3_progress, param);
}]],
/* [] */
0]);
var write_processor_job = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "name", t.name),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Id_bs$SolvuuApi0.write_job, "job_id", t.job_id),
  /* [] */
  0]]);
});
var read_processor_job = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    name: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("name", Atdgen_codec_runtime.Decode.string, param);
    }, json),
    job_id: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("job_id", Id_bs$SolvuuApi0.read_job, param);
    }, json)
  };
});

function write__1(param) {
  return Atdgen_codec_runtime.Encode.contramap(Int64_wrap$SolvuuApi0.unwrap, Atdgen_codec_runtime.Encode.string, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.map(Int64_wrap$SolvuuApi0.wrap, Atdgen_codec_runtime.Decode.string, param);
}

function write__4(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(Checksum_bs$SolvuuApi0.write_t, param);
}

var read__4 = Atdgen_codec_runtime.Decode.option_as_constr(Checksum_bs$SolvuuApi0.read_t);

function write__3(param) {
  return Atdgen_codec_runtime.Encode.option_as_constr(write__1, param);
}

var read__3 = Atdgen_codec_runtime.Decode.option_as_constr(read__1);
var write_create_upload = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__2, "source", t.source),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__3, "size", t.size),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, write__4, "checksum", t.checksum),
  /* [] */
  0]]]);
});
var read_create_upload = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    source: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("source", read__2, param);
    }, json),
    size: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("size", read__3, param);
    }, json),
    checksum: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("checksum", read__4, param);
    }, json)
  };
});
var write_create = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x[0] >= -960135725) {
    return Atdgen_codec_runtime.Encode.constr1("Unsafe_link", write_storage, x[1]);
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Upload", write_create_upload, x[1]);
  }
});
var read_create = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Upload",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Upload */
      [-1058128351, x]
    );
  }, read_create_upload, param);
}]],
/* :: */
[
/* tuple */
["Unsafe_link",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Unsafe_link */
      [-960135725, x]
    );
  }, read_storage, param);
}]],
/* [] */
0]]);
var write_info = Atdgen_codec_runtime.Encode.make(function (x) {
  if (typeof x === "number") {
    if (x >= -560624458) {
      return Atdgen_codec_runtime.Encode.constr0("Validate");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("Complete");
    }
  } else {
    var variant = x[0];

    if (variant >= 301598491) {
      if (variant >= 816044828) {
        if (variant >= 925682913) {
          return Atdgen_codec_runtime.Encode.constr1("Size", write__1, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Create", write_create, x[1]);
        }
      } else if (variant >= 773206832) {
        return Atdgen_codec_runtime.Encode.constr1("Processor_job", write_processor_job, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Storage", write_storage, x[1]);
      }
    } else if (variant >= 112490979) {
      return Atdgen_codec_runtime.Encode.constr1("Checksum", Checksum_bs$SolvuuApi0.write_t, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Progress", write_progress, x[1]);
    }
  }
});
var read_info = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Create",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Create */
      [816044828, x]
    );
  }, read_create, param);
}]],
/* :: */
[
/* tuple */
["Storage",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Storage */
      [301598491, x]
    );
  }, read_storage, param);
}]],
/* :: */
[
/* tuple */
["Progress",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Progress */
      [-539184179, x]
    );
  }, read_progress, param);
}]],
/* :: */
[
/* tuple */
["Complete",
/* `Single */
[-306849112,
/* Complete */
-646333223]],
/* :: */
[
/* tuple */
["Size",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Size */
      [925682913, x]
    );
  }, read__1, param);
}]],
/* :: */
[
/* tuple */
["Checksum",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Checksum */
      [112490979, x]
    );
  }, Checksum_bs$SolvuuApi0.read_t, param);
}]],
/* :: */
[
/* tuple */
["Validate",
/* `Single */
[-306849112,
/* Validate */
-560624458]],
/* :: */
[
/* tuple */
["Processor_job",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Processor_job */
      [773206832, x]
    );
  }, read_processor_job, param);
}]],
/* [] */
0]]]]]]]]);
var write_event = Event_bs$SolvuuApi0.write_t;
var read_event = Event_bs$SolvuuApi0.read_t;
var write__7 = Event_bs$SolvuuApi0.write_t(write_info);
var read__7 = Event_bs$SolvuuApi0.read_t(read_info);
var read_s3_location = S3_bs$SolvuuApi0.read_location;
var write_s3_location = S3_bs$SolvuuApi0.write_location;
var read_id = Id_bs$SolvuuApi0.read_blob;
var write_id = Id_bs$SolvuuApi0.write_blob;
var read_job_id = Id_bs$SolvuuApi0.read_job;
var write_job_id = Id_bs$SolvuuApi0.write_job;
var read_int64 = read__1;
var write_int64 = write__1;
var read_checksum = Checksum_bs$SolvuuApi0.read_t;
var write_checksum = Checksum_bs$SolvuuApi0.write_t;
var read_t = read__7;
var write_t = write__7;
export { read_s3_location, write_s3_location, read_id, write_id, read_storage, write_storage, read_s3_progress_part, write_s3_progress_part, read_s3_progress_report, write_s3_progress_report, read_s3_progress, write_s3_progress, read_progress, write_progress, read_job_id, write_job_id, read_processor_job, write_processor_job, read_int64, write_int64, read_checksum, write_checksum, read_create_upload, write_create_upload, read_create, write_create, read_info, write_info, read_event, write_event, read_t, write_t };
/* write_storage Not a pure module */